export default {
    namespaced: true,
    state: {
        menu: null,
    },
    actions: {
        getModules: async function ({ commit, dispatch }) {
            commit("setMenu", {
                data: JSON.parse(localStorage.getItem("menu-selected") ?? 0),
            });
        },
        setModules: async function ({ commit, dispatch }, payload) {
            localStorage.setItem("menu-selected", payload.option);
            commit("setMenu", { data: payload.option });
        },
    },
    mutations: {
        setMenu(state, payload) {
            state.menu = payload.data;
        },
    },
};
